module.exports = __webpack_public_path__ + "img/myguard_pro_banner_01.397e6da7.jpg";